module.exports = __webpack_public_path__ + "static/media/google.bc95375e.png";